import { SET_LOADER, SET_SIDEBAR } from "./../actions/uiActions";

const initState = {
  loading: false,
  showSidebar: true
};

export const uiReducer = (ui = initState, action) => {
  switch (true) {
    case action.type.includes(SET_LOADER):
      return { ...ui, loading: action.payload };
    case action.type.includes(SET_SIDEBAR):
      return { ...ui, showSidebar: action.payload };
    default:
      return ui;
  }
};

export default uiReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/uiReducer.js